
// Library imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";
import styled from "styled-components";
import axios from "axios";

// Local imports
import {
  AUDIENCE_LISTS,
  AUDIENCE_LISTS_DETAILS,
} from "constants/types";
import { PEOPLE_AUDIENCE } from "constants/actionTypes";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import { closeDetailProfile, setAudienceFilterApplied } from "modules/GlobalActions";
import { getQueryListId } from "utils";
import CreateContactSidebar from "../People/CreateContactSidebar";
import {
  getAudienceListDetails,
  reloadListDetails,
  resetApplySelectedFiltersListDetails,
  resetAudienceFiltersForExport,
  resetAudienceFilterToggle,
  resetAudienceListDetails,
  resetAudienceListDetailsPeopleSearch,
  resetAudienceListDetailsProfiled,
  resetAudiencePeopleTabData,
  resetSelectedFiltersListDetails,
  setSelectedFiltersListDetails,
} from "./actions";
import ListDetailsTab from "./ListDetailsTab";
import ProfiledList from "./ProfiledList";
import { getDesignations, getOrganizations, getAudienceAllPeopleList, setAudiencePeopleSearchTerm } from "../actions";
import { useParams } from "react-router";
import { AudienceParams } from "../Components/AudienceHeader";
import { TAB_AUDIENCE } from "constants/paths";
import { IAudienceFilters } from "../interface";

interface IAudienceListView {
  showImportListAsider: boolean;
  setShowImportListAsider: (arg0: boolean) => void;
  page: string;
  addPeopleMode: boolean;
  handleAddPeopleMode: (mode: boolean, addGlobalContactMode?: boolean) => void;
  tabStateSearch?: boolean;
  addGlobalPeopleMode?: boolean;
}

const AudienceListView: React.FC<IAudienceListView> = ({
  showImportListAsider,
  setShowImportListAsider,
  page,
  addPeopleMode,
  handleAddPeopleMode,
  tabStateSearch,
  addGlobalPeopleMode
}) => {
  const { tab, subTab } = useParams<AudienceParams>();
  // Local states
  let source = axios.CancelToken.source();
  const [updateTotalCount, setUpdateTotalCount] = useState<boolean>(false);
  const [clearFiltersCheck, setClearFiltersCheck] = useState(false); // alter this state to trigger get contacts call without any filters

  // Redux states
  const listId: string = useSelector((state: RootState) => state.audienceListDetails.listId);
  const newlyCreatedListId: string = useSelector(
    (state: RootState) => state.audienceListDetails.newlyCreatedListId
  );
  const openEditContactSidebar = useSelector((state: RootState) => state.peopleAudience.openEditContactSidebar);
  const audienceFiltersApplied: boolean = useSelector(
    (state: RootState) => state.uiReducer.audienceFiltersApplied
  );
  const audienceListFiltersForExport = useSelector((state: RootState) => state.audienceLists.listAudienceFilters);
  const searchTermListDetails = useSelector((state: RootState) => state.audienceListDetails.searchTermListDetails);
  const appliedFilters = useSelector((state: RootState) => state.audienceListDetails.filters);
  const selectedFilters = useSelector((state: RootState) => state.audienceListDetails.selectedFilters);
  const allPeopleList = useSelector((state: RootState) => state.peopleAudience.allPeople);
  const selectedOrganization = selectedFilters?.organizations;
  const selectedDesignation = selectedFilters?.designations;
  const selectedPersonalityType = selectedFilters?.personality;
  const selectedStatus = selectedFilters?.status;

  const [exportContactsFilterParams, setExportContactsFilterParams] = useState({ ...audienceListFiltersForExport });


  // Component Logic
  // useEffect(() => {
  //   if (
  //     selectedOrganization.length === 0 &&
  //     selectedDesignation.length === 0 &&
  //     selectedPersonalityType.length === 0 &&
  //     selectedStatus.length === 0 &&
  //     audienceFiltersApplied
  //   ) {
  //     clearFiltersHandler();
  //   }
  // }, [selectedOrganization, selectedDesignation, selectedPersonalityType, selectedStatus]);

  const resetFilters = () => {
    resetApplySelectedFiltersListDetails();
    resetSelectedFiltersListDetails();
    resetAudienceListDetailsProfiled();
    resetAudienceFilterToggle();
  };

  const exportPeopleFiltersUpdate = () => {
    let exportContactsFilterParamsObj: any = {
      filter_by_organization: selectedOrganization,
      filter_by_designation: selectedDesignation,
      personality_type: selectedPersonalityType,
      status: selectedStatus,
    };
    setExportContactsFilterParams(exportContactsFilterParamsObj);
    store.dispatch({
      type: AUDIENCE_LISTS.FILTERS,
      filters: exportContactsFilterParamsObj,
    });
  };

  const clearFiltersHandler = (reloadAudience?: boolean) => {
    resetFilters();
    exportPeopleFiltersUpdate(); // reset the filters in the store for export
    setClearFiltersCheck(!clearFiltersCheck);
    resetAudienceListDetailsProfiled(); // reset list contacts on clear filters

    if (addPeopleMode) {
      reloadAudience !== false && getAudienceAllPeopleList(
        20,
        0,
        "all",
        searchTermListDetails,
        [],
        [],
        [],
        [],
        "contact_name",
        "ASC",
        "",
        ""
      ); // To get All contacts with empty filters in addPeopleMode

      store.dispatch({
        type: PEOPLE_AUDIENCE.SET_FILTERS,
        payload: {
          designations: [],
          organizations: [],
          personality: [],
          status: [],
          searchTerm: searchTermListDetails,
        },
      });
      resetAudiencePeopleTabData();
    }

    if (audienceFiltersApplied) {
      setAudienceFilterApplied(false);
    }
  };

  // useEffect(() => {
  //   if (skipInitialMount) {
  //     setSkipInitialMount(false);
  //   } else {
  //     resetFilters();
  //   }
  // }, [tabState]);

  useEffect(() => {
    if (newlyCreatedListId.toString() !== "" && listId !== newlyCreatedListId.toString()) {
      getAudienceListDetails(source.token); // get newly created list details
      clearFiltersHandler(); // reset filters on list change
    }
  }, [newlyCreatedListId]);

  useEffect(() => {
    if (listId !== getQueryListId().toString()) {
      resetAudienceListDetails();
      getAudienceListDetails(source.token);
      getOrganizations(getQueryListId().toString());
      getDesignations(getQueryListId().toString());
    }
    return () => {
      // reload list after import
      let reloadList = store.getState().audienceListDetails.reloadList;
      if (reloadList) {
        reloadListDetails(false, 'profiled');
      }
      // cancelling the request when unmounted
      if (source) {
        source.cancel("List Details Component fot Unmount.");
      }

      // reset filters on unmount only if pathname is not /audiences/lists/view or /audience/lists/view/all
      let windowPathname = window.location.pathname;
      let newAudienceFilterApplied = store.getState().uiReducer.audienceFiltersApplied;
      if (!windowPathname.includes("/audiences/lists/view") && newAudienceFilterApplied) {
        setAudienceFilterApplied(false);
        resetSelectedFiltersListDetails();
        resetApplySelectedFiltersListDetails();
        resetAudienceFiltersForExport();
      }

      closeDetailProfile(); // close pserson detail asider on unmount

      if (!(windowPathname.includes("/audiences/lists/view/all")) && searchTermListDetails !== "") {
        store.dispatch({
          type: AUDIENCE_LISTS_DETAILS.SET_SEARCH_TERM,
          searchTermListDetails: "",
        });
        resetAudienceListDetailsPeopleSearch();
        setAudiencePeopleSearchTerm("");
        resetAudiencePeopleTabData();
      }
      if (!(windowPathname.includes("/audiences/lists/view/all")) && !(windowPathname.includes("/audiences/lists/view"))) {
        resetAudienceFilterToggle();
      }
    };
  }, []);

  const handleSelectedFilters = (values: string[], type: string) => {
    let newSelectedFilters: IAudienceFilters = { ...selectedFilters };
    newSelectedFilters[type as keyof IAudienceFilters] = values;
    setSelectedFiltersListDetails(newSelectedFilters);
  };

  return (
    <Wrapper className="audience-content-inner-01">
      <div className="audience-content-inner">
        <ListDetailsTab
          tabState={"profiled"}
          showImportListAsider={showImportListAsider}
          setShowImportListAsider={setShowImportListAsider}
          updateTotalCount={updateTotalCount}
          setUpdateTotalCount={setUpdateTotalCount}
          selectedDesignation={selectedDesignation}
          setSelectedDesignation={(value: string[]) => handleSelectedFilters(value, 'designations')}
          selectedOrganization={selectedOrganization}
          setSelectedOrganization={(value: string[]) => handleSelectedFilters(value, 'organizations')}
          selectedPersonalityType={selectedPersonalityType}
          setSelectedPersonalityType={(value: string[]) => handleSelectedFilters(value, 'personality')}
          selectedStatus={selectedStatus}
          setSelectedStatus={(value: string[]) => handleSelectedFilters(value, 'status')}
          resetFilters={resetFilters}
          clearFiltersCheck={clearFiltersCheck}
          setClearFiltersCheck={setClearFiltersCheck}
          clearFiltersHandler={clearFiltersHandler}
          exportContactsFilterParams={exportContactsFilterParams}
          exportPeopleFiltersUpdate={exportPeopleFiltersUpdate}
          page={page}
          addPeopleMode={addPeopleMode}
          handleAddPeopleMode={handleAddPeopleMode}
          addGlobalPeopleMode={addGlobalPeopleMode}
        />
        {!addGlobalPeopleMode &&
          <ProfiledList
            isProfiled={true}
            setUpdateTotalCount={setUpdateTotalCount}
            clearFiltersCheck={clearFiltersCheck}
            exportPeopleFiltersUpdate={exportPeopleFiltersUpdate}
            tabStateSearch={tabStateSearch}
            addPeopleMode={addPeopleMode}
            handleAddPeopleMode={handleAddPeopleMode}
          />
        }
      </div>
      {tab === TAB_AUDIENCE.VIEW && subTab === undefined ?
        <FloatingSidebarTwo isToggle={openEditContactSidebar}>
          <CreateContactSidebar detailProfileAsider={true} editSidebar={true} />
        </FloatingSidebarTwo> : null}
    </Wrapper>
  );
};

export default AudienceListView;

const Wrapper = styled.div`
  .audience-content-inner {
    /* position: relative;
    z-index: 5; */
    .floating-footer {
      z-index: 5;
    }
    > div {
      z-index: 5;
    }
    .footer-sider {
      @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 330px;
      }
    }
  }
`;
